import { CSSObject } from '@wegroup/design-system';
import useCurrentGroup from '../../../../hooks/useCurrentGroup';

interface Props {
  isFullWidth?: boolean;
  isColumnsEnabled?: boolean;
  isExpandedGrid?: boolean;
}

/**
 * This hook should be used to retrieve the grid config
 * IMPORTANT: Do not use this hook for a input itself
 */
const useInputGridProps = ({
  isFullWidth,
  isColumnsEnabled,
  isExpandedGrid,
}: Props): CSSObject => {
  const currentGroup = useCurrentGroup();
  const amountOfQuestions = currentGroup.questions.length;

  const defaultProps = {
    gridTemplateColumns: 'minmax(0, 45rem)',
    w: '100%',
    maxW: '1000px',
  };

  const isFullWidthProps = {
    ...defaultProps,
    gridTemplateColumns: '1fr',
  };

  const isColumnsEnabledProps = {
    ...defaultProps,
    gridTemplateColumns: {
      base: 'minmax(0px, 45rem)',
      tablet: 'repeat(2, minmax(0px, 45rem))',
    },
  };

  const isExpandedGridProps = {
    ...defaultProps,
    w: 'auto',
    alignSelf: 'center',
    gridTemplateColumns: {
      base: 'repeat(1, 1fr)',
      tabletS: `repeat(${Math.min(amountOfQuestions, 2)}, auto)`,
      tablet: `repeat(${Math.min(amountOfQuestions, 3)}, auto)`,
      laptopL: `repeat(${Math.min(amountOfQuestions, 4)}, auto)`,
    },
    maxW: '1800px',
  };

  const getOverrideGridProps = () => {
    if (isExpandedGrid) {
      return isExpandedGridProps;
    }

    if (isFullWidth) {
      return isFullWidthProps;
    }

    if (isColumnsEnabled) {
      return isColumnsEnabledProps;
    }

    return defaultProps;
  };

  return getOverrideGridProps();
};

export default useInputGridProps;
